import { gsap } from "gsap";
import { Flip } from "gsap/Flip";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { TextPlugin } from "gsap/TextPlugin";

gsap.registerPlugin(Flip, ScrollTrigger, ScrollToPlugin, TextPlugin);

//this is just an example plugin that allows us to animate a "blur" property like gsap.to(target, {blur:10}) and it'll feed that value to this plugin which will do all the necessary calculations to add/update a blur() value in the CSS "filter" property (in browsers that support it). We wrap it in an iife just so that we can declare some local variables in a private scope at the top.
(function () {
    const blurProperty = gsap.utils.checkPrefix("filter"),
        blurExp = /blur\((.+)?px\)/,
        getBlurMatch = target => (gsap.getProperty(target, blurProperty) || "").match(blurExp) || [];

    gsap.registerPlugin({
        name: "blur",
        get(target) {
            return +(getBlurMatch(target)[1]) || 0;
        },
        init(target, endValue) {
            let data = this,
                filter = gsap.getProperty(target, blurProperty),
                endBlur = "blur(" + endValue + "px)",
                match = getBlurMatch(target)[0],
                index;
            if (filter === "none") {
                filter = "";
            }
            if (match) {
                index = filter.indexOf(match);
                endValue = filter.substr(0, index) + endBlur + filter.substr(index + match.length);
            } else {
                endValue = filter + endBlur;
                filter += filter ? " blur(0px)" : "blur(0px)";
            }
            data.target = target;
            data.interp = gsap.utils.interpolate(filter, endValue);
        },
        render(progress, data) {
            data.target.style[blurProperty] = data.interp(progress);
        }
    });
})();

const homeAnimation = () => {

    /** To avoid mobile browsers to hide address bar. 
     * If browser hides address bar during scoll animation 
     * the animation jumps becuase the viewport height has changed
     * and therefore the position of the scrollbar.*/
    ScrollTrigger.normalizeScroll(true);


    //Our work pin project container and scroll horizontally through projects
    let mm = gsap.matchMedia();
    let projects = gsap.utils.toArray(".project");
    let sections = gsap.utils.toArray("section");
    mm.add({
        isSmall: "(max-width:767px)",
        isDefault: "(min-width:768px) and (max-width:1279px)",
        isLarge: "(min-width:1280px)",
    }, (context) => {
        let { isSmall, isLarge } = context.conditions;

        // How we work 
        sections.forEach(panel => {
            // how we work line separators width from 0 to 100%
            var bline = panel.querySelectorAll(".bline");
            gsap.to(bline,
                {
                    scrollTrigger: {
                        // markers: true,
                        trigger: panel,
                        start: "top 40%",
                        toggleActions: "play none none none",
                        invalidateOnRefresh: true,
                    },
                    width: "100%",
                    duration: 1.5,
                    ease: "power2.out",
                });

            // how we work text section text color block light grey to dark grey    
            var hww = panel.querySelectorAll(".hww");
            gsap.to(hww,
                {
                    scrollTrigger: {
                        trigger: panel,
                        start: "top 40%",
                        toggleActions: "play none none none",
                        invalidateOnRefresh: true,
                    },
                    color: "#111827",
                    duration: 1.3,
                    ease: "power3.out",
                });
        });

        
        gsap.to(projects, {
            xPercent: () => {
                if (isSmall) {
                    return -100 * (projects.length - 1) - 1.52 * (projects.length - 1);
                } else if (isLarge) {
                    return -100 * (projects.length - 3) - 4.72 * (projects.length - 3);
                } else {
                    return -100 * (projects.length - 2) - 3.1 * (projects.length - 2);
                }
            },
            ease: "power1.inOut",
            scrollTrigger: {
                trigger: '.project-container',
                start: "top 20%",
                mediateRender: false,
                // start: "bottom bottom-=100px",
                // toggleActions: "restart resume reverse resume",
                // pin: true,
                // pinSpacer: false,
                scrub: true,
                snap: false,
                // markers: true,
                normalizeScroll: true,              
                end: () => {
                    let triggEnd = document.querySelector('#projects') ? document.querySelector('#projects').offsetWidth  : 0;
                    return "+=" + triggEnd;
                }
            },
            delay: 0.2,
            duration: 0.8,
        });


        gsap.to(".project-container", {
            scrollTrigger: {
                trigger: '.project-container',
                start: "top 20%",
                pin: true,
                scrub: true,
                snap: false,
                normalizeScroll: true,
                // markers: true,
                end: () => {
                    let triggEnd = document.querySelector('#projects') ? document.querySelector('#projects').offsetWidth + 150 : 150;
                    return "+=" + triggEnd;
                }
            }
        });
    
        //animate background color change from white to black
        gsap.to(".content, .backdrop",
            {
                scrollTrigger: {
                    trigger: '#tech',
                    // markers: true,
                    start: "top 50%",
                    end: "+=300",
                    toggleActions: "restart resume reverse resume",
                    invalidateOnRefresh: true,
                    scrub: true,
                },
                backgroundColor: '#000000',
                duration: 1,
                ease: "power1.out",
            });

        //animate background color for backdrop behind menu so it is transparent when
        //over the video but gets solid when further down the page
        gsap.to(".backdrop",
            {
                scrollTrigger: {
                    trigger: '.main-text',
                    // markers: true,
                    start: "top top",
                    end: "+=10",
                    toggleActions: "play play reverse reverse",
                    invalidateOnRefresh: true,
                    onEnterBack: ({ progress, direction, isActive }) => console.log(progress, direction, isActive),
                },
                opacity: 1,
                duration: 0
            });

    });

    var frameCount = 55;
    var flower = document.querySelector('#flower');


    var tl = gsap.timeline();

    //from now on, we can animate "blur" as a number! (Well, in browsers that support filter)
    tl.fromTo("h1.transformation",
        { opacity: 0 },
        {
            opacity: 1,
            duration: 1,
            ease: "power1.out",
            delay: 0.5
        }, 0)
        .fromTo("#flower",
            { y: 0 }, {
            y: () => -(flower.clientHeight / frameCount) * (frameCount - 1),
            ease: "steps(" + (frameCount - 1) + ")",
            duration: 7,
            repeat: -1,
            yoyo: true,          
        },0)
        .fromTo(" h1.claim",
            { opacity: 0, blur: 8 },
            {
                opacity: 1,
                duration: 1,
                ease: "power1.out",
                blur: 0,
                stagger: {
                    each: 3.0,
                    repeat: 1,
                    repeatDelay: 0.75,
                    yoyo: true
                },
                repeat: -1,
                delay: 0.5
            }, 0);
        // .fromTo("h1.claim.first",
        //     { opacity: 0, blur: 8 },
        //     {
        //         opacity: 1,
        //         duration: 1,
        //         ease: "power1.out",
        //         blur: 0,
        //         repeat: 0,
        //         delay: 0.5
        //     }, "+=0.5");

            window.addEventListener("resize", () => {
                tl.pause();
                tl.invalidate();
                tl.resume();
                
            });

}

export default homeAnimation;